import { QidCompanyDocument } from "server/models"

export interface QidCompanyDocumentList { [fileId: number]: QidCompanyDocument }

export interface QidCompanyDocumentState {
    documentList: QidCompanyDocumentList
    documentIds: number[]

    reloadList: boolean
}

export const QID_COMPANY_DOCUMENT_LIST = "QID_COMPANY_DOCUMENT_LIST"
export const QID_COMPANY_DOCUMENT_RELOAD_LIST = "QID_COMPANY_DOCUMENT_RELOAD_LIST"
